import {
    INVALID_ID,
    EMPTY_STRING,
    INVALID_DATE,
} from '@Utils/constants'

// List of all Interview Module Selectors
export const getDefaultFilters = ({ interviewsList }) => interviewsList.searchFilter;
export const getListPageTitle = ({ interviewsList }) => interviewsList.searchLabel;
export const getListAlertModal = ({ interviewsList }) => interviewsList.alert;
export const getListConfirmModal = ({ interviewsList }) => interviewsList.confirmModal;

// Table selectors
export const getCurrentPage = ({ interviewsList }) => interviewsList.searchFilter.Pagination.Page;
export const getSortModel = ({ interviewsList }) => interviewsList.resultTable.appliedFilter.Pagination.Sort;
export const getRowsPerPage = ({ interviewsList }) => interviewsList.resultTable.rowsPerPage;
export const isTableLoading = ({ interviewsList }) => interviewsList.resultTable.loading;
export const getTableData = ({ interviewsList }) => interviewsList.resultTable.data;
export const getTotalCount = ({ interviewsList }) => interviewsList.resultTable.totalCount;
export const getTableSelectedRows = ({ interviewsList }) => interviewsList.resultTable.selectedRows;


// Interviews Add Form
export const getAddFormData = ({ interviewsAdd }) => interviewsAdd.addForm;
export const getAlertModalData = ({ interviewsAdd }) => interviewsAdd.alert;
export const getShowLoading = ({ interviewsAdd }) => interviewsAdd.loading;
export const getHolidayDates = ({ interviewsAdd }) => interviewsAdd.holidayDates;
export const getAddEmailTemplate = ({ interviewsAdd }) => interviewsAdd.emailTemplate;


// Interviews Detail Form
export const hasLoadedData = ({ interviewsDetail }) => interviewsDetail.hasLoadedData;
export const getFormTitle = ({ interviewsDetail }) => interviewsDetail.title;
export const getDetailData = ({ interviewsDetail }) => interviewsDetail.detailForm;
export const getEditable = ({ interviewsDetail }) => interviewsDetail.isEditable;
export const getDetailMode = ({ interviewsDetail }) => interviewsDetail.mode;
export const getDetailAlertModal = ({ interviewsDetail }) => interviewsDetail.alert;
export const getDetailConfirmModal = ({ interviewsDetail }) => interviewsDetail.confirmModal;
export const getDetailEmailTemplate = ({ interviewsDetail }) => interviewsDetail.emailTemplate;


export const validateAddForm = (values) => {
    let errors = {};

    if (values.applicantID === INVALID_ID) {
        errors[`applicantID`] = 'Name of Applicant is required!'
    }

    if (values.interviewer === INVALID_ID) {
        errors[`interviewer`] = 'Interviewer is required!'
    }

    if (values.interviewSchedule === INVALID_DATE) {
        errors[`interviewSchedule`] = 'Interview Schedule is required!'
    }

    if (values.interviewMode === INVALID_ID) {
        errors[`interviewMode`] = 'Interview Mode is required!'
    }

    if (values.addressOrLink === EMPTY_STRING) {
        errors[`addressOrLink`] = 'Address or Link is required!'
    }

    return errors;
}

export const validateDetailForm = (values) => {
    let errors = {};

    if (values.applicantID === INVALID_ID) {
        errors[`applicantID`] = 'Name of Applicant is required!'
    }

    if (values.interviewer === INVALID_ID) {
        errors[`interviewer`] = 'Interviewer is required!'
    }

    if (values.interviewSchedule === INVALID_DATE) {
        errors[`interviewSchedule`] = 'Interview Schedule is required!'
    }

    if (values.interviewMode === INVALID_ID) {
        errors[`interviewMode`] = 'Interview Mode is required!'
    }

    if (values.addressOrLink === EMPTY_STRING) {
        errors[`addressOrLink`] = 'Address or Link is required!'
    }

    return errors;
}